<template>

  <v-sheet class="rounded pa-4">

    <v-checkbox 
      label         = "Header" 
      dense 
      hide-details
      v-model       = "layout.header.visible"
    >
    </v-checkbox>

    <v-checkbox 
      label         = "File Toolbar" 
      dense 
      hide-details
      v-model       = "layout.fileToolbar.visible"
    >
    </v-checkbox>

    <v-checkbox 
      label         = "Video Player" 
      dense 
      disabled
      hide-details
      v-model       = "layout.videoPlayer.visible"
    >
    </v-checkbox>

    <v-checkbox 
      label         = "Timeline" 
      dense 
      hide-details
      v-model       = "layout.timeline.visible"
    >
    </v-checkbox>

    <v-checkbox 
      label         = "Top Tabs" 
      dense 
      hide-details
      v-model       = "layout.topTabs.visible"
    >
    </v-checkbox>

    <v-checkbox 
      label         = "Bottom Tabs" 
      dense 
      hide-details
      v-model       = "layout.bottomTabs.visible"
    >
    </v-checkbox>

  </v-sheet>

</template>

<script>

export default {

  // #region Properties

  props: {
    layout: Object
  }

  // #endregion Properties

}

</script>